import React, { useEffect, useState } from 'react';
import { checkUserRole } from '../../utils/common';

import {
  TextField,
  InputLabel,
  FormControl,
  Select,
  MenuItem,
  InputAdornment,
  IconButton,
  Switch,
  FormControlLabel,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import LoadingButton from '@mui/lab/LoadingButton';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

const FormSection = styled('div')(() => ({
  width: '100%',
  display: 'flex',
  flexWrap: 'wrap',
  gap: '8px',
  alignItems: 'center',
}));

const CustomInput = styled('input')(() => ({
  backgroundColor: '#D0D0D1',
  borderRadius: '6px',
  border: '1px solid transparent',
  padding: '10px',
  boxSizing: 'border-box',
  fontSize: '14px',
  color: '#5B5C5D',
  width: '350px',
}));

const CustomTextField = styled(TextField)(() => ({
  backgroundColor: '#D0D0D1',
  borderRadius: '6px',
  '& input': {
    color: '#5B5C5D',
  },
  width: '350px',
  height: 'auto',
}));

const BasicSelect = styled(Select)(() => ({
  backgroundColor: '#D0D0D1',
  borderColor: '#5B5C5D',
  borderRadius: '6px',
  '& input': {
    color: '#5B5C5D',
  },
  width: '350px',
}));

const StyledButton = styled(LoadingButton)(() => ({
  minWidth: '150px',
  padding: '8px 16px',
  borderRadius: '6px',
  fontSize: '14px',
  alignSelf: 'flex-start',
}));

const DetailsForm = ({
  email,
  setEmail,
  userType,
  setUserType,
  handleAddUser,
  group,
  setGroup,
  edit,
  addUserLoader,
  selectedEmail,
  setSelectedEmail,
  behalf,
  password,
  setPassword,
  canAcceptAm,
  setCanAcceptAm,
}) => {
  const [selectDisable, setSelectDisable] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (value) => {
    setEmail(value);
  };

  const handlerSelect = (event) => {
    setSelectedEmail(event.target.value.trim());
  };

  const handleSelect = (event) => {
    setUserType(event.target.value);
  };

  const handleGroupSelect = (event) => {
    setGroup(event.target.value);
  };

  useEffect(() => {
    if (checkUserRole() === 'admin') {
      if (edit) {
        setSelectDisable(true);
      } else {
        setUserType('agent');
        setSelectDisable(true);
      }
    }
  }, [edit, setUserType]);

  return (
    <FormSection>
      <CustomInput
        type="text"
        id="emailId"
        onChange={(e) => handleChange(e.target.value)}
        value={email}
        placeholder="Please enter email"
        disabled={edit}
      />

      <FormControl size="small" disabled={selectDisable}>
        <InputLabel id="select-label">Select user type</InputLabel>
        <BasicSelect
          labelId="select-label"
          id="select"
          value={userType}
          label="Select user type"
          onChange={handleSelect}
        >
          <MenuItem value={'admin'}>Admin</MenuItem>
          <MenuItem value={'agent'}>Agent</MenuItem>
        </BasicSelect>
      </FormControl>

      <FormControl size="small">
        <InputLabel id="select-label-group">Select user Group</InputLabel>
        <BasicSelect
          labelId="select-label-group"
          id="select-group"
          value={group}
          label="Select user Group"
          onChange={handleGroupSelect}
        >
          <MenuItem value={'sales'}>Sales</MenuItem>
          <MenuItem value={'support'}>Support</MenuItem>
          <MenuItem value={'development'}>Development</MenuItem>
        </BasicSelect>
      </FormControl>

      <CustomInput
        type="text"
        id="select-behalf"
        placeholder="Please enter behalf email"
        onChange={handlerSelect}
        value={behalf}
        disabled={edit}
        autoComplete="off"
      />

      <CustomTextField
        type={showPassword ? 'text' : 'password'}
        id="password"
        label="Set/Update Password (optional)"
        size="small"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        autoComplete="new-password"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={() => setShowPassword((prev) => !prev)} edge="end" size="small">
                {showPassword ? <VisibilityOffIcon fontSize="small" /> : <VisibilityIcon fontSize="small" />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />

      <FormControlLabel
        control={
          <Switch
            checked={canAcceptAm}
            onChange={(e) => setCanAcceptAm(e.target.checked)}
            color="primary"
          />
        }
        label="Can Accept A.M."
      />

      <StyledButton
        variant="contained"
        onClick={() => handleAddUser()}
        loading={addUserLoader}
      >
        {edit ? 'Update user' : 'Add user'}
      </StyledButton>
    </FormSection>
  );
};

export default DetailsForm;
